export default [
    'asterisk',
    'dagger',
    'double-dagger',
    'double-vertical-line',
    'section',
    'pilcrow'
];
